import React, { memo, useContext } from 'react';
import { AppContext } from '@prisjakt/ui-app-context';
import { ParamsAndReturnTypes } from '@prisjakt/ui-translate/src/translate-func';
import { IconVerfied, IconHomeDelivery } from '@prisjakt/ui/icon';
import { Price } from '../../../../../../../types';

import * as S from './styles';

type OwnProps = {
  className?: string;
  countryCode?: string | null;
  isInternationalPrice?: boolean;
  deliveryOptions?: Price['deliveryOptions'];
  brandRecommendedRetailer?: boolean;
  showCircles?: boolean;
};

const StoreTags = ({
  className,
  countryCode,
  isInternationalPrice = false,
  deliveryOptions = [],
  brandRecommendedRetailer,
  showCircles,
}: OwnProps) => {
  const { t } = useContext(AppContext);
  const homeDelivery =
    deliveryOptions &&
    deliveryOptions.find(option => option && option.type === 'HOME_DELIVERY');

  return (
    <S.BadgeWrapper className={className}>
      {brandRecommendedRetailer && (
        <>
          <S.BadgeDesktop
            icon={IconVerfied}
            text={t('store', 'brand.recommended-retailer')}
            showCircles={showCircles}
          />
          <S.BadgeMobile icon={IconVerfied} showCircles={showCircles} />
        </>
      )}

      {homeDelivery && (
        <>
          <S.BadgeDesktop
            icon={IconHomeDelivery}
            text={t('product', 'home-delivery.info')}
            showCircles={showCircles}
          />
          <S.BadgeMobile icon={IconHomeDelivery} showCircles={showCircles} />
        </>
      )}
      {countryCode && isInternationalPrice && (
        <S.CountryFlag
          show={isInternationalPrice}
          countryCode={countryCode}
          title={t(
            'common',
            `market.${countryCode}` as keyof ParamsAndReturnTypes['common']
          )}
          tooltipPlacement="top"
        />
      )}
    </S.BadgeWrapper>
  );
};

export default memo(StoreTags);
